import axios from 'axios';

export default (headers = { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' }) =>
  axios.create({
    baseURL: '/v2/erp/utils',
    timeout: 15000,
    headers,
    withCredentials: true,
    auth: {
      username: process.env.VUE_APP_API_ERP_LOGIN,
      password: process.env.VUE_APP_API_ERP_PASSWORD,
    },
    responseType: 'json',
  });
